export default __webpack_public_path__ + "static/media/phone.680a795d.svg";